module.exports = __webpack_public_path__ + "static/media/educationIcon.8a4dbdd4.svg";